var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "order-filter-panel d-flex flex-column",
      staticStyle: { height: "100%" },
    },
    [
      _c(
        "v-toolbar",
        {
          staticClass: "flex-grow-0",
          attrs: { flat: "", dense: "", color: "toolbar" },
        },
        [
          _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-filter-variant")]),
          _c(
            "v-toolbar-title",
            { staticClass: "text-subtitle-1 font-weight-medium" },
            [_vm._v("Filters")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        {
          staticClass: "pa-4 flex-grow-1",
          staticStyle: { "overflow-y": "auto" },
        },
        [
          _c("v-autocomplete", {
            staticClass: "mb-4",
            attrs: {
              items: _vm.pageOptions,
              "item-text": "page_name",
              "item-value": "page_name",
              label: "Page",
              clearable: "",
              "auto-select-first": "",
              dense: "",
              outlined: "",
              "hide-details": "",
              "background-color": "input",
              "menu-props": { maxHeight: 260 },
            },
            model: {
              value: _vm.model.page_name,
              callback: function ($$v) {
                _vm.$set(_vm.model, "page_name", $$v)
              },
              expression: "model.page_name",
            },
          }),
          _vm.showArgFilters
            ? _c("v-autocomplete", {
                staticClass: "mb-4",
                attrs: {
                  items: _vm.featureTypeOptions,
                  "item-text": "position_name",
                  "item-value": "position_name",
                  label: "Feature Type",
                  clearable: "",
                  "auto-select-first": "",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                  "background-color": "input",
                  "menu-props": { maxHeight: 260 },
                },
                model: {
                  value: _vm.model.position_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "position_name", $$v)
                  },
                  expression: "model.position_name",
                },
              })
            : _vm._e(),
          _c("v-autocomplete", {
            staticClass: "mb-4",
            attrs: {
              items: _vm.departmentOptions,
              "item-text": "department",
              "item-value": "department",
              label: "Department",
              clearable: "",
              "auto-select-first": "",
              dense: "",
              outlined: "",
              "hide-details": "",
              "background-color": "input",
              "menu-props": { maxHeight: 260 },
            },
            model: {
              value: _vm.model.department,
              callback: function ($$v) {
                _vm.$set(_vm.model, "department", $$v)
              },
              expression: "model.department",
            },
          }),
          _c("v-checkbox", {
            staticClass: "mt-0 mb-2",
            attrs: { label: "Shippers/Pallets", "hide-details": "" },
            model: {
              value: _vm.model.is_shipper,
              callback: function ($$v) {
                _vm.$set(_vm.model, "is_shipper", $$v)
              },
              expression: "model.is_shipper",
            },
          }),
          _vm.showArgFilters && _vm.showOrderFilters
            ? _c("v-checkbox", {
                staticClass: "mt-0 mb-2",
                attrs: { label: "Items With Orders", "hide-details": "" },
                model: {
                  value: _vm.model.has_orders,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "has_orders", $$v)
                  },
                  expression: "model.has_orders",
                },
              })
            : _vm._e(),
          _vm.showArgFilters && _vm.showOrderFilters
            ? _c("v-checkbox", {
                staticClass: "mt-0 mb-2",
                attrs: { label: "Features With Notes", "hide-details": "" },
                model: {
                  value: _vm.model.has_notes,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "has_notes", $$v)
                  },
                  expression: "model.has_notes",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "pa-3 d-flex align-center flex-grow-0" },
        [
          _c(
            "v-btn",
            {
              attrs: { text: "", small: "", disabled: !_vm.stagedCount },
              on: { click: _vm.clearAll },
            },
            [_vm._v("Clear all")]
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { color: "primary", small: "" },
              on: { click: _vm.apply },
            },
            [_vm._v("Apply")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }